import discardReadReceiptOption from './actions/discardReadReceiptOption';
import saveReadReceiptOption from './actions/saveReadReceiptOption';
import ReadReceiptsFull from './components/ReadReceiptsFull';
import isReadReceiptOptionDirty from './utils/isReadReceiptOptionDirty';
import * as React from 'react';
var ReadReceiptsOption = {
    key: 'readReceipts',
    titleStringKey: 'optionTitle_readReceipts',
    searchTermsStringKey: 'optionTitle_readReceipts',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ReadReceiptsFull, null); },
        isDirty: isReadReceiptOptionDirty,
        onSave: saveReadReceiptOption,
        onDiscard: discardReadReceiptOption,
    },
};
export default ReadReceiptsOption;
//# sourceMappingURL=ReadReceiptsOption.js.map